import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { AssetMasterModule } from "@/store/modules/asset.module";
import { Guid } from "guid-typescript";
import Loader from "../../../components/widgets/loader.vue";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import simplebar from "simplebar-vue";
/**
 * View Asset Components
 */
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let ViewAsset = /** @class */ (() => {
    let ViewAsset = class ViewAsset extends Mixins(BaseMixer) {
        constructor() {
            // DATA
            super(...arguments);
            this.pageIsLoading = true;
            this.ctaButtons = [{ routeName: "assetManager" }];
            this.showAssetHistory = false;
            this.title = "View Asset";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Assets",
                    href: "#",
                },
                {
                    text: "Asset Manager",
                    to: "/assetManager",
                },
                {
                    text: "View Asset",
                    active: true,
                },
            ];
        }
        assetHistory(assetId) {
            AssetMasterModule.GetAssetHistory(this.assetId).then((response) => {
                if (response) {
                    this.showAssetHistory = true;
                }
            });
        }
        roundNumber(number, decimals) {
            var newnumber = new Number(number + "").toFixed(parseInt(decimals));
            return parseFloat(newnumber);
        }
        closeAssetHistory() {
            this.showAssetHistory = false;
            this.$bvModal.hide("asset-histories");
        }
        get assetsHistory() {
            return AssetMasterModule.assetHistory;
        }
        get assetRepair() {
            return AssetMasterModule.assetRepair;
        }
        get assetsView() {
            return AssetMasterModule.assetsView;
        }
        get assetsPropertiesView() {
            return AssetMasterModule.assetProperties;
        }
        get assetPrice() {
            return this.roundNumber(this.assetsView.price, 2).toFixed(2);
        }
        get canEditAssetTypeProperties() {
            return this.rightsHelper(this.rightsConstant.AssetManager.CanEditAssetTypeProperties());
        }
        get canEditAssetDetails() {
            return this.rightsHelper(this.rightsConstant.AssetManager.CanEditAssetDetails());
        }
        //Lifecycle
        created() {
            this.assetId = Guid.parse(this.$route.params.assetId);
            AssetMasterModule.GetAssetsView(this.assetId).then((response) => {
                if (response) {
                    this.pageIsLoading = false;
                }
            });
        }
    };
    ViewAsset = __decorate([
        Component({
            name: "ViewAsset",
            components: {
                Layout,
                Loader,
                PageHeader,
                SectionLoader,
                simplebar,
            },
        })
    ], ViewAsset);
    return ViewAsset;
})();
export default ViewAsset;
